<template>
    <modal :show="modalBool" @close="modalBool = false">
      <template #header>
        <h5 id="exampleModalLabel" class="modal-title">
          {{ $t(isUpdate ? "Edit record" : "New Record") }}
        </h5>
      </template>
      <div>
        <div class="pl-lg-6">
          <div class="row">
            <div class="col-lg-12">
              <base-input
                  v-model="service.name.en"
                  alternative=""
                  :label="$t('Service name (english)')"
                  :placeholder="$t('Service name (english)')"
                  input-classes="form-control-alternative"
                  :error="v$.service.name.en.$errors.map( err => { return err.$message })[0]"
              />
            </div>
            <div class="col-lg-12">
              <base-input
                  v-model="service.name.el"
                  alternative=""
                  :label="$t('Service name (greek)')"
                  :placeholder="$t('Service name (greek)')"
                  input-classes="form-control-alternative"
              />
            </div>
            <div class="col-lg-12">
              <div class="form-group has-label" :class="{'has-danger': v$.service.employeeType.$error }">
                <label class="form-control-label">{{ $t("Employee type") }}</label>
                <multiselect
                    v-model="service.employeeType"
                    :show-labels="false"
                    :placeholder="$t('Select type')"
                    :options="['nurse','doctor', 'physiotherapist']" :multiple="false"
                    :error="v$.service.employeeType.$errors.map( err => { return err.$message })[0]"
                >
                  <template #singleLabel="{ option }">{{ $t(option) }}</template>
                  <template #option="props">
                    {{ $t(props.option) }}
                  </template>
                </multiselect>
                <div v-if="v$.service.employeeType.$invalid" class="text-danger invalid-feedback" style="display: block;">
                  {{ v$.service.employeeType.$errors.map( err => { return err.$message })[0] }}
                </div>
              </div>
            </div>
            <div v-if="['doctor', 'physiotherapist'].includes(service.employeeType)" class="col-lg-12">
<!--              employeeType-->
              <base-input
                  v-model="service.cost"
                  alternative=""
                  type="number"
                  label="Service Cost (€)"
                  placeholder="Slot cost"
                  input-classes="form-control-alternative"
              >
              </base-input>
            </div>
            <div class="col-lg-12">
              <base-input
                  :label="$t('Description (english)')"
                  alternative=""
              >
                <textarea
                    v-model="service.description.en"
                    rows="4"
                    class="form-control form-control-alternative"
                    placeholder="Description (english)"
                >
                </textarea>
              </base-input>
            </div>
            <div class="col-lg-12">
              <base-input
                  :label="$t('Description (greek)')"
                  alternative=""
              >
                <textarea
                    v-model="service.description.el"
                    rows="4"
                    class="form-control form-control-alternative"
                    placeholder="Description (greek)"
                >
                </textarea>
              </base-input>
            </div>
            <template v-if="!isService">
            <div class="row">
              <h5 class="text-start">Time Slots</h5>
            </div>
            <div v-for="(slot, index) in service.timeSlots" :key="slot" class="row">
              <div class="col-lg-4">
                <div class="form-group has-label">
                  <label class="form-control-label">{{ $t("Start time") }}</label>
                  <VueDatePicker
                    v-model="slot.startTime"
                    :locale="$store.state.locale"
                    :select-text="$t('Select')"
                    :cancel-text="$t('Cancel')"
                    :start-time="{ hours: 10, minutes: 0 }"
                    :time-picker="true"
                    :time-picker-inline="true"
                    minutes-increment="10"
                    minutes-grid-increment="10"
                    format="HH:mm"
                    :flow="['time']"
                    :placeholder="$t('Shift start')"
                ></VueDatePicker>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group has-label">
                  <label class="form-control-label">{{ $t("End time") }}</label>
                  <VueDatePicker
                      v-model="slot.endTime"
                      :locale="$store.state.locale"
                      :select-text="$t('Select')"
                      :cancel-text="$t('Cancel')"
                      :start-time="{ hours: 10, minutes: 0 }"
                      :time-picker="true"
                      :time-picker-inline="true"
                      minutes-increment="10"
                      minutes-grid-increment="10"
                      format="HH:mm"
                      :flow="['time']"
                      :placeholder="$t('Shift start')"
                  ></VueDatePicker>
                </div>
              </div>
              <div class="col-lg-3">
                <base-input
                    v-model="slot.priceInCents"
                    alternative=""
                    type="number"
                    label="Cost (€)"
                    placeholder="Slot cost"
                    input-classes="form-control-alternative"
                >
                </base-input>
              </div>
              <div class="col-lg-1">
                <button class="mt-4 btn btn-outline-danger" @click="service.timeSlots.splice(index, 1)"><i class="fa fa-minus"></i></button>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2 text-start">
              <button class="mt-4 btn btn-outline-dark " @click="service.timeSlots.push({startTime: null,endTime: null,priceInCents: null})"><i class="fa fa-plus"></i></button>
              </div>
            </div>
            </template>
          </div>
        </div>
      </div>
      <template #footer>
        <submit-button
            :alert-message="errorMessage"
            :state="loadingProcess"
            @clicked="submit()"
        >
          {{ $t("Submit") }}
        </submit-button>
      </template>
    </modal>
</template>

<script>
import Modal from "@/components/Modal"
import BaseInput from "@/components/BaseInput"
import SubmitButton from "@/components/SubmitButton"
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"
import {countDecimals, getPercentage, toCents} from "@/helpers/common"
import useVuelidate from "@vuelidate/core"
import {helpers, required, email, requiredIf, minLength} from "@vuelidate/validators"
const customFloatValidation = (value) => {
  console.log("value", value.toString().split(".")[1])
  let dec = value.toString().split(".")[1]

  if (dec){
    return dec.length <=2
  }
  return true
}

export default {
  name: "ServiceForm",
  components: {SubmitButton, BaseInput, Modal},
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      modalTitle: "New Service",
      modalBool: true,
      loadingProcess: "",
      errorMessage: "",
      service: {
        name: {en: "", el: ""},
        cost: null,
        description: {en: "", el: ""},
        type: null,
        employeeType: null,
        timeSlots: [
          {
            startTime: null,
            endTime: null,
            priceInCents: null
          }
        ],
      }
    }
  },
  validations () {
    return {
      service: {
        employeeType: {
          required
        },
        name: {
          en: {
            required
          }
        },
      }
    }
  },
  computed: {
    isUpdate() {
      return  ["editShiftPlanRecord", "editServiceRecord"].includes(this.$route.name)
    },
    isService() {
      return  ["newService", "editServiceRecord", "serviceRecord"].includes(this.$route.name)
    },
    // calcRate() {
    //   return rate => (getPercentage(rate, this.$store.state.settings.companyCommissionRatePercent).toFixed(2) + "/" +
    //       getPercentage(rate, this.$store.state.settings.employeeRatePercent).toFixed(2))
    // }
  },
  watch: {
    modalBool(newVal) {
      if (!newVal){
        console.log("modalBool namenamename", this.$route.name)
        console.log("modalBool includes", ["editServiceRecord", "newService"].includes(this.$route.name))
        this.$router.push({ path: ["editServiceRecord", "newService"].includes(this.$route.name) ? "/services" : "/shift-plans" })
      }
    },
  },
  async mounted() {

    if (this.isUpdate) {
      const serv = await this.$store.dispatch("fetchDoc", {
        path: "services",
        id: this.$route.params.id
      })

      console.log("servvvv", serv)
      this.service.type = serv.type
      this.service.name = serv.name
      this.service.employeeType = serv.employeeType
      this.service.description = serv.description
      const self = this
      if (serv.timeSlots != null) {
        this.service.timeSlots = serv.timeSlots.map(slot => {
          return {
            startTime: self.toTimeObject(slot.startTime),
            endTime: self.toTimeObject(slot.endTime),
            priceInCents: slot.priceInCents / 100
          }
        })
      } else {
        this.service.cost = serv.priceInCents / 100
      }
    }
  },
  methods:{
    toTimeObject(time){
      const [hours, minutes] = time.split(":").map(Number)
      return { hours, minutes, seconds: 0 }
    },
    submit(){

      this.v$.$touch()

      if (this.v$.service.$invalid) {
        console.log(this.v$.$errors)
        return
      }

      if (this.service.name.el === ""){
        delete this.service.name.el
      }
      if (this.service.description.el === ""){
        delete this.service.description.el
      }

      const payload = {
        name: this.service.name,
        description: this.service.description,
        employeeType: this.service.employeeType
      }

      if (this.isUpdate){
        payload.id = this.$route.params.id
      }

      if (!this.isService) {
        payload.type = "shift"
        // payload.priceInCents = null
        payload.timeSlots = JSON.parse(JSON.stringify(this.service.timeSlots)).map(slot => {
          console.log("slot", slot)
          return {
            startTime: this.$moment(slot.startTime).format("HH:mm"),
            endTime: this.$moment(slot.endTime).format("HH:mm"),
            priceInCents: slot.priceInCents*100,
          }
        })
      } else {
        payload.type = "service"
        payload.priceInCents = 0
        payload.priceInCents = ["doctor", "physiotherapist"].includes(this.service.employeeType) ? this.service.cost*100 : 0
        delete payload.cost
      }

      console.log("payload", payload)

      this.loadingProcess = "processing"
      let self = this
      FirebaseFunctionsHelper.callFunction(
          this.isUpdate ? "service-update" : "service-create",
          payload
      )
          .then(async (result) => {
            console.log("res", result)
            // eslint-disable-next-line no-prototype-builtins
            if (result != null && result.hasOwnProperty("message")) {
              console.log("resmessage", result.message)
              this.loadingProcess = "failed"
              this.errorMessage = result.message
              return
            }
            console.log("submitUser result", result)
            // this.$store.commit("SET_EXPIRE_POSITIONS")
            this.loadingProcess = ""
            this.modalBool = false
          }, this)
          .catch((error) => {
            self.loadingProcess = "failed"
            self.errorMessage = error.message
            console.log("submitUser error", error)
          })
    },
  },
}
</script>

<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

@media (min-width: 776px) {
  .modal-dialog{
    max-width: 50% !important;
  }
}

</style>